export const GLOBAL_BUSINESS_VARIABLES = {
  totalStockAvailable: {
    defaultValue: '15',
    stringValueWithM: '15M',
    numberValue: 15,
    numberValueExtended: '15.000.000',
  },
};
